import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { Lab } from '../../models/lab';

const getInhouseLabSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Lab>) => Object
        .values(byId)
        .find(x => x && x.inHouse)
);

const getLabByNameSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<Lab>) => memoize((
        name: string
    ) => {
        const nameLower = name.toLowerCase();
        return Object
            .values(byId)
            .find(x => x!.labName && x!.labName.toLowerCase() === nameLower);
    })
);

export const selectors = {
    getInhouseLab: (
        state: State
    ): Undefinable<Lab> => getInhouseLabSelector(state),
    getLab: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<Lab> => state.byId[id || ''],
    getLabByName: (
        state: State,
        name: string
    ): Undefinable<Lab> => getLabByNameSelector(state)(name),
    getLabIds: (
        state: State
    ): number[] => state.allIds
};
